export const TRUCK_LIST = 'nex/truckList';
export const CATEGORY_LIST = 'nex/categoryList';
export const SENDOTP = 'nex/sendOtp';
export const VERIFYOTP = 'nex/verifyOtp';
export const REGISTER = 'nex/register';
export const REGISTERWITHOTP = 'nex/registerWithOtp';
export const LOGIN = 'nex/login';
export const CUSTOMER_DETAILS = 'customer/details';
export const CHANGE_PASS = 'customer/changePass';
export const ENQUIRY = 'nex/enquiry';
export const BOOKING = 'payment/booking';
export const GET_BOOKING = 'payment/getBookings';